import React, {useState} from "react";
import "./ImageViewer.sass"
import PropTypes from "prop-types";

export default function ImageViewer(props) {
    const [item, setItem] = useState(0)

    const {photos, title, onClose} = props

    const renderPhotos = () => {
        return photos.map((photo, i) =>
            <div key={`photo-${i}`}
                 onClick={() => setItem(i)}
                 className={"viewer-small" + (item === i ? " viewer-small-focus" : "")}>
                <img src={photo} alt={title}/>
            </div>)
    }

    return (
        <div className="viewer-wrapper" onClick={onClose}>
            <div className="viewer-content" onClick={(e) => {e.stopPropagation()}}>
                <div className="viewer-photo">
                    <img src={photos[item]} alt={""}/>
                </div>
                <div className="viewer-photos-wrapper">
                    <div className="viewer-photos">
                        {photos && photos.length > 0 && renderPhotos()}
                    </div>
                </div>
            </div>
        </div>
    )
}

ImageViewer.propTypes = {
    photos: PropTypes.array,
    title: PropTypes.string,
    onClose: PropTypes.func,
}